import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AiFillFilePdf, AiFillDelete } from "react-icons/ai";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import { openModalAction } from "../../Redux/actions/modal";
import InboxModal from "../InboxModal/InboxModal";
import toast, { Toaster } from "react-hot-toast";
import EmptyInbx from "../Loaders/Empty";

const InboxMessage = () => {
  const dispatch = useDispatch();
  const { modal } = useSelector((state) => state);
  const { isModalOpen } = modal;
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    fetchInboxMessages();
  }, []);

  const fetchInboxMessages = async () => {
    const token = localStorage.getItem("token");
    console.log("Fetching user details with token:", token);

    if (!token) {
      console.error("No token found in local storage.");
      toast.error("No token found. Please log in again.");
      return;
    }

    try {
      const response = await fetch("https://backend.pmc-group.uk/api/inbox", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("Response status:", response.status);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetched inbox messages:", data);

      if (data && Array.isArray(data.data)) {
        setMessages(data.data);
      } else {
        console.error(
          "API response does not contain an array of messages:",
          data
        );
        toast.error("Failed to fetch inbox messages. Invalid response format.");
      }
    } catch (error) {
      console.error("Error fetching inbox messages:", error);
      toast.error("Failed to fetch inbox messages. Please try again.");
    }
  };

  const openInboxModalHandler = (messageId) => {
    dispatch(openModalAction());
  };

  return (
    <div className="p-0 m-0 box-border">
      <Toaster />
      {isModalOpen && <InboxModal />}
      <div className="w-[90%] mx-auto pt-1 lg:pt-4 pb-12">
        <div className="w-full mx-auto sidebar py-8 shadow-xl bg-white rounded-lg">
          <h2 className="text-xl text-navBg font-semibold px-6 py-4">
            Inbox Message
          </h2>
          <div className="flex justify-start items-center gap-4 my-4">
            {messages.length > 0 ? (
              messages.map((message) => (
                <div
                  key={message.id}
                  className="w-[300px] mx-4 shadow-2xl rounded-md"
                >
                  <div
                    onClick={() => openInboxModalHandler(message.id)}
                    className="w-[100px] h-[100px] cursor-pointer mx-auto my-4 rounded-md"
                  >
                    <AiFillFilePdf className="w-full h-full text-[#B30B00]" />
                  </div>
                  <p
                    onClick={() => openInboxModalHandler(message.id)}
                    className="text-center text-sm font-semibold cursor-pointer font-Inter "
                  >
                    {message.title}
                  </p>
                  <div className="flex justify-between items-center py-4 mx-4">
                    <p>{new Date(message.date).toLocaleDateString()}</p>
                    <div className="text-red-500 text-2xl hover:text-[#B30B00] cursor-pointer">
                      <AiFillDelete />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="flex flex-col justify-center items-center w-full py-16">
                <EmptyInbx />
                <p className="mt-8 text-center text-gray-600 font-semibold text-lg">
                  You are yet to receive any messages.
                </p>
                <p className="text-center text-gray-500">
                  Keep an eye on this space for updates.
                </p>
              </div>
            )}
          </div>
          <div className="flex justify-end items-end gap-2 mx-4 py-6">
            <div className=" flex justify-center items-center w-[40px] h-[40px] cursor-pointer rounded-full bg-gray-200 hover:bg-gray-500 hover:text-white">
              <FaArrowLeft />
            </div>
            <div className="flex justify-center items-center w-[40px] h-[40px] cursor-pointer rounded-full bg-gray-200 hover:bg-gray-500 hover:text-white">
              <FaArrowRight />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InboxMessage;
